import type { DiscoveredRouteModule, DiscoveryResult } from './types';

function isValidRouteModule(candidate: any): candidate is DiscoveredRouteModule {
  return !!candidate && typeof candidate === 'object' &&
    typeof candidate.id === 'string' &&
    (candidate.scope === 'root' || candidate.scope === 'app' || candidate.scope === 'admin') &&
    typeof candidate.name === 'string' &&
    typeof candidate.path === 'string' &&
    !!candidate.component;
}

export function discoverRoutes(eager = true): DiscoveryResult {
  const strict = import.meta.env.VITE_ROUTING_DISCOVERY_STRICT === 'true';
  const files = eager
    ? import.meta.glob('/src/routes/**/*.route.ts', { eager: true })
    : import.meta.glob('/src/routes/**/*.route.ts');
  const routes: DiscoveredRouteModule[] = [];
  const errors: string[] = [];
  const warnings: string[] = [];

  for (const [path, mod] of Object.entries(files)) {
    const route = (mod as any)?.route;
    if (!isValidRouteModule(route)) {
      const msg = `Invalid route module at ${path}`;
      if (strict) errors.push(msg); else warnings.push(msg);
      continue;
    }

    // Basic duplicate check (by id + name)
    const dupById = routes.find(r => r.id === route.id);
    const dupByName = routes.find(r => r.name === route.name && r.scope === route.scope);
    if (dupById || dupByName) {
      const msg = `Duplicate route detected: ${route.id} / ${route.name} (${path})`;
      if (strict) errors.push(msg); else warnings.push(msg);
      continue;
    }

    routes.push(route);
  }

  return { routes, errors, warnings };
}


